interface BuildItemsParams {
  eventBeingDeleted?: any;
  events: Array<any>;
  hiddenUsersIds?: Array<number>;
  isMapDisplayed?: boolean;
  onEventCardClick: any;
  selectedEvent?: any;
}

export const buildItems = ({
  eventBeingDeleted,
  events = [],
  hiddenUsersIds,
  isMapDisplayed,
  onEventCardClick,
  selectedEvent,
}: BuildItemsParams) =>
  events.map((event) => ({
    id: event.id,
    event,
    key: `${event.type}-${event.id}`,
    onClick: onEventCardClick,
    selected:
      selectedEvent &&
      selectedEvent.id === event.id &&
      selectedEvent.type === event.type,
    blocked:
      event.type === 'event' && hiddenUsersIds?.includes(event.organizer.id),
    loading:
      eventBeingDeleted &&
      eventBeingDeleted.id === event.id &&
      eventBeingDeleted.type === event.type,
    hoverStyle: isMapDisplayed
      ? 'box-shadow: 0 4px 30px 0 rgba(0, 0, 0, 0.2);'
      : null,
  }));

export const colWidthBreakpoints = ({
  isMapDisplayed,
}: {
  isMapDisplayed: boolean;
}) => ({
  s: 1,
  m: 6 / 12,
  l: 4 / 12,
  xl: isMapDisplayed ? 0.5 : 0.25,
});

export const perPageBreakpoints = ({
  isMapDisplayed,
  singleLine,
}: {
  isMapDisplayed: boolean;
  singleLine: boolean;
}) =>
  singleLine
    ? { s: 1, m: 2, l: 3, xl: isMapDisplayed ? 2 : 4 }
    : { s: 8, m: 8, l: 9, xl: isMapDisplayed ? 4 : 8 };
